import PostsUserPage from 'flarum/forum/components/PostsUserPage';
/**
 * The `DislikesUserPage` component shows posts which user the user disliked.
 */
export default class DislikesUserPage extends PostsUserPage {
  params(user) {
    return {
      filter: {
        type: 'comment',
        dislikedBy: user.id()
      }
    };
  }
}
flarum.reg.add('nodeloc-dislikes', 'forum/components/DislikesUserPage', DislikesUserPage);